import {Injectable, Inject, PLATFORM_ID, signal} from '@angular/core';
import {DOCUMENT, isPlatformBrowser} from '@angular/common';

@Injectable({providedIn: 'root'})
export class AppVisibilityService {
  // Signal que contiene true si la pestaña está visible
  public readonly visibility = signal<boolean>(true);

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // Solo en navegador real
    if (isPlatformBrowser(this.platformId)) {
      // Estado inicial
      this.visibility.set(!this.document.hidden);

      // Actualizar Signal en cada cambio de visibilidad
      this.document.addEventListener('visibilitychange', () => {
        this.visibility.set(!this.document.hidden);
      });
      this.document.addEventListener('beforeunload', () => {
        this.visibility.set(false);
      })


    } else {
      this.visibility.set(true);
    }
  }
}
